import { useBulkActionsState } from '../hooks/useBulkActionsState';
export const useBulkActionsRawCache = () => {
  const state = useBulkActionsState();
  return state.cache;
};